import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import style from './style.scss';//NOSONAR

let timeout = {};

const Input = (props) => {

    const [isValid, setIsValid] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [count, setCount] = useState(0);
    const callbackValidate = props.callbackValidate ? props.callbackValidate : () => {};
    const callbackOnChange = props.callbackOnChange ? props.callbackOnChange : () => {};

    const {label, type, name, className, message, textArea, defaultValue, placeholder, maxLength, required, counter}  = props;

    useEffect(() => {
        if(defaultValue){
            _onChange({target: {value: defaultValue}});
        }
    },[defaultValue]);

    useEffect(() => {
        return function cleanup(){
            timeout[name] = null 
        }
    },[])

    const _onChange = (event) => {
        const value = event.target ? event.target.value : '';
        characterLimit(event)
        const validate = callbackValidate(value);
        setIsValid(validate)
        callbackOnChange(name, validate, value);
        setShowMessage(false);

        if(!timeout[name]) timeout[name] = null;

        clearTimeout(timeout[name]);
        if(validate){
            setShowMessage(false);
        }else{
            timeout[name] = setTimeout(()=>{
                setShowMessage(true)
            },500);
        }
    }

    const characterLimit = (e) => {
        const init = e.target.value.length;
        setCount(init);
    }

    const sendProps = {
        type,
        defaultValue,
        name,
        placeholder,
        onChange: _onChange,
        className: (className ? className : ''),
        onBlur: _onChange,
        maxLength,
    }

    return (
        <div className={"input-text-wrapper " + (!isValid && showMessage  ? ' is-error' : '')}>

            <div className="input-text-label-content">
                <label className="title-label">
                    {label}
                </label>

                {required && <div className="input-text-required">Obligatorio</div>}
            </div>
            


            {textArea ? <textarea {...sendProps}/> : <input {...sendProps}/>}

            <div className="input-menssage-content">
                {message && <p className='message-error'>
                    {message.error}
                </p>}

                {counter && <div className="textarea-character-limit">{count}/150 caracteres</div>}
            </div>

        </div>
    )
}

Input.propTypes = {
    type: PropTypes.string,
    defaultValue: PropTypes.string,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    className: PropTypes.string,
    message: PropTypes.object,
    callbackValidate: PropTypes.func,
    callbackOnChange: PropTypes.func,
    textArea: PropTypes.bool,
    maxLength: PropTypes.number
}
export default Input;
